<template>
   <div class="header">
    <img src="/assets/logo-aemps.svg" alt="Logo AEMPS" class="logo">
    <h1>
        Cartas de Seguridad a <br>los Profesionales Sanitarios

    </h1>
   </div>

  </template>

<script>

</script>
